import { ButtonType, ButtonWidget } from '@tableau/widgets';
import * as React from 'react';

import { CommonStyles } from '../../../common/react/CommonStyles';
import { imgPath } from '../../../common/utilities/ImgUrl';
import { ReactDirectiveProps } from '../../../ts/directives/reactDirectiveFactory';
import { GuidePanel } from './GuidePanel';

const guideStyle: React.CSSProperties = {
  width: '924px',
  height: '534px',
  fontSize: CommonStyles.Sizes.SmallFontSize,
  color: CommonStyles.Colors.Grey102
};

const tableauLogoSize = '75px';
const logoStyle: React.CSSProperties = {
  height: tableauLogoSize,
  width: tableauLogoSize,
  display: 'block',
  marginRight: 'auto',
  marginLeft: 'auto',
  marginTop: CommonStyles.Sizes.XLargeSpace
};

const titleStyle: React.CSSProperties = {
  textAlign: 'center',
  fontSize: '24px',
  marginTop: CommonStyles.Sizes.XLargeSpace,
  fontFamily: CommonStyles.Fonts.HeaderFont
};

const subtitleStyle: React.CSSProperties = {
  textAlign: 'center',
  marginTop: CommonStyles.Sizes.LargeSpace,
  fontSize: CommonStyles.Sizes.NormalFontSize,
  fontFamily: CommonStyles.Fonts.HeaderFont
};

const panelContainerStyle: React.CSSProperties = {
  marginTop: CommonStyles.Sizes.XLargeSpace + CommonStyles.Sizes.LargeSpace,
  display: 'flex',
  justifyContent: 'space-around'
};

const dismissButtonStyle: React.CSSProperties = {
  marginTop: CommonStyles.Sizes.XLargeSpace,
  marginRight: 'auto',
  marginLeft: 'auto',
  display: 'block',
  textAlign: 'center'
};

export class GettingStartedGuide extends React.Component<GettingStartedGuide.Props, GettingStartedGuide.State> {

  private renderDismissButton(): JSX.Element {
    if (this.props.dismissButtonText) {
      return (
        <p style={dismissButtonStyle}>
          <ButtonWidget handleClick={this.props.dismissButtonFunction} buttonType={ButtonType.Go} testId="dismiss-getting-started-guide-btn"> {this.props.dismissButtonText} </ButtonWidget>
        </p>);
    } else {
      return null;
    }
  }

  private renderSubtitle(): JSX.Element {
    if (this.props.subtitle) {
      return (<div className="tb-guide-subtitle" style={subtitleStyle}> { this.props.subtitle } </div>);
    } else {
      return null;
    }
  }

  public render() {
    return (
      <div className="tb-guide-container" style={guideStyle}>

        <img src={imgPath('tableau_sparkle.png')} alt="Tableau logo" style={logoStyle} />
        <div className="tb-guide-title" style={titleStyle}> { this.props.title }</div>

        {this.renderSubtitle()}

        <div className="tb-panel-container" style={panelContainerStyle}>
          { this.props.guidePanels.map((panelComponent:GuidePanel, key:number) => (
            <div key={ key }>
              { panelComponent }
            </div>
          ))}
        </div>

        {this.renderDismissButton()}

      </div>
     );
  }
}

export module GettingStartedGuide {

  export interface Props extends ReactDirectiveProps {
    title: string;
    subtitle?: string;
    guidePanels: GuidePanel[]; // TODO transition to using CallToActionPanels, which will have titles. Story 611398:
    dismissButtonText?: string;
    dismissButtonFunction?: () => void;
  }

  export interface State {}

}
